export default {
  national: "nacional",
  regional: "región",
  school: "institucional",
  day: "Día",
  days: "Días",
  week: "Semana",
  month: "Mes",
  listening: "Escucha",
  speaking: "Habla",
  reading: "Lectura",
  writing: "Escritura",
  points: "Puntos",
  hours: "Horas",
  dismiss: "Descartar",
  close: "Cerrar",
  record: "Grabar",
  listen: "Escuchar",
  repeat: "Repetir",
  translate: "Traducir",
  timer: "Cronómetro",
  next: "Siguiente",
  validate: "Validar",
  you: "Mío",
  native: "Nativo",
  checkText: "Revisa el texto nuevamente",
  congratulations: "Felicitaciones",
  needHelp: "¿Necesitas ayuda?",
  instructions: "Instrucciones",
  continue: "Continuar",
  userSnapButton: "Informar error",
  startIntroductionButton: "Comenzar Introducción",
  certificationTest: {
    created:
      "Estás apto para hacer el Prueba de Certificación. Habla con tu profesor o profesora para marcarlo y, mientras tanto, continúa repasando el contenido de tu curso para prepararte para la prueba.",
    scheduled: "Tu Prueba de Certificación está marcado para {scheduledTo} ",
    enabled: "Tu Prueba de Certificación está disponible para que lo hagas.",
    continue: "Continúa tu  Prueba de Certificación ahora.",
    awaitingRevision:
      "Tu Prueba de Certificación será evaluado en breve. Recibirás una notificación en algunos días con el resultado.",
    reviewed: "Tu Prueba de Certificación ha sido revisado.",
    failed: "No alcanzaste la nota necesaria en tu último Prueba de Certificación.",
    button: {
      start: "INICIAR PRUEBA DE CERTIFICACIÓN",
      continue: "CONTINUAR PRUEBA DE CERTIFICACIÓN",
      reviewed: "VISUALIZAR RESULTADO",
      back: "Volver al Curso",
      access: "Entrar",
      accessNewCourse: "Entrar en el nuevo Curso",
    },
    execution: {
      title: "Obtén una nota mínima de 70 para habilitar el próximo paso que está bloqueado.",
      completedTitle: "Prueba de Certificación finalizado y enviado para revisión.",
      completedDescription:
        "¡Después de la revisión de tu prueba por el evaluador, recibiras una notificación con tu nota! \n ¡Buena suerte!",
      ability: {
        reading: "Prueba de Lectura",
        writing: "Prueba de Escritura",
        speaking: "Prueba de Habla",
        listening: "Prueba de Escucha",
      },
      status: {
        finished: "Done",
        available: "Start",
        blocked: "Locked",
      },
    },
    result: {
      failedTitle: "¡Oh no!",
      failedDescription: "No alcanzaste la nota necesaria para pasar en el Prueba de Certificación.",
      failedDescriptionTwo: "Habla con tu profesor o profesora para intentar el Prueba de Certificación de nuevo.",
      approvedTitle: "¡Excelente!",
      approvedDescription: "Has conseguido la nota necesaria para pasar en el Prueba de Certificación.",
      approvedDescriptionTwo:
        "Nos probaste que has aumentado tu nivel de Inglés en la escala del Marco Común Europeo de Referencia para las lenguas.",
      scoreBySkill: "Nota por habilidad",
      finalScore: "Nota final",
      unlockedCourse: "Curso desbloqueado",
    },
    help: {
      gotIt: "Entendí",
      free_speak:
        "En este ejercicio, diferente de las unidades, no debe repetir la pregunta mostrada, pero sí responderla. Usted tendrá hasta 1 minuto para pensar en su respuesta antes de que el registro se inicie automáticamente. Si lo desea, también puede iniciar antes.",
      free_speak_image:
        "En este ejercicio usted debe describir la imagen mostrada. Usted tendrá hasta 1 minuto para pensar en su respuesta antes de que el registro se inicie automáticamente. Si lo desea, también puede iniciar antes.",
    },
  },
  help: {
    DICTATION: "Escucha atentamente el audio del nativo y <b>escribe</b> la frase en el campo abajo.",
    GAP_FILL_MULTIPLE: "Completa la frase <b>arrastrando</b> las palabras correctas hasta los espacios disponibles.",
    UNSCRAMBLE_DRAG_AND_DROP:
      "Organiza la frase <b>arrastrando</b> las palabras correctas hasta los espacios disponibles.",
    PRESENTATION:
      "Utiliza los botones Repetir, Grabar y Escucha para <b>grabar tu voz</b> repitiendo el audio del nativo.",
    PRONUNCIATION: "Utiliza el Grabar para <b>decir el texto</b> que está a continuación.",
    GAP_FILL_SELECT: "Completa la frase <b>seleccionando</b> una de las opciones disponibles.",
    SINGLE_CHOICE_AUDIO: "Escucha la pregunta y <b>clica</b> en la opción correcta.",
    SINGLE_CHOICE_TEXT: "Escucha la pregunta y <b>clica</b> en la opción correcta.",
    SINGLE_CHOICE_IMAGE: "Escucha la pregunta y <b>clica</b> en la opción correcta.",
    SPEECH_PRACTICE: "<b>Escucha</b> atentamente y utiliza el Grabar para <b>repetir</b> el audio.",
    GAP_FILL: "Grave la frase <b>completa</b> con la opción correcta.",
    UNSCRAMBLE_SPEECH_RECOGNITION:
      "Organiza la frase utilizando el botón Grabar para <b>grabar la frase</b> en la secuencia correcta.",
    TEXT: "<b>Lee el texto atentamente</b> y después utiliza el botón Siguiente para continuar.",
    TRUE_FALSE: "Escucha la afirmación y <b>clica</b> en verdadero o falso.",
  },
  items: {
    placeholder: {
      gapFillSelect: "Selecciona una opción",
      freeSpeak: "En {time} segundos el registro se iniciará automáticamente. Consiga antes si quiere.",
    },
    dictation: {
      errorTitle: "Verifica la lista abajo para entender los errores en tu frase:",
      moreWordsError: "En tu frase hay {count} palabras que están de sobra.",
      missingWordsError: "En tu frase faltan {count} palabras",
      wordsWithTyposError: "Palabras con errores en la forma de escribirlas: ",
      wrongWordsError: "Palabras equivocadas: ",
    },
    speechRecognition: {
      historyTitle: "Tus intentos",
      tryAgain: "¡Inténtalo de nuevo!",
      errorLowScore: "Nosotros no conseguimos generar una nota para tu habla, por favor inténtalo de nuevo.",
      errorNoSpeech: "No conseguimos detectar tu habla, por favor inténtalo de nuevo.",
    },
  },
  intro: {
    next: "Avanzar",
    previous: "Volver",
    skip: "Saltar",
    done: "Concluir",
    gotIt: "Entendí",
    steps: {
      gapFillSelect: "Selecciona una de las opciones para completar la frase.",
      singleChoiceImage: "Escucha el audio y selecciona la imagen correspondiente.",
      singleChoiceText: "Escucha el audio y selecciona el item correspondiente.",
      singleChoiceAudio: "Escucha el audio y selecciona una de las opciones correspondientes.",
      gapFill1: "El texto está incompleto. Es necesario completarlo con una de las opciones.",
      gapFill2: "Clica y selecciona una de las opciones.",
      unscrambleDragDrop1: "Aquí será necesario organizar la frase a partir de las opciones disponibles.",
      unscrambleDragDrop2: "Estas son las opciones. ¡Arrastra los items para montar el texto!",
      gapFillMultiple1: "El texto está incompleto. Es necesario completarlo con las opciones correctas.",
      gapFillMultiple2: "Estas son las opciones. ¡Arrastra los items para montar el texto!",
      controlBar1: "Botón para repetir el audio. ¡Recuerda que solo podrás usarlo una vez!",
      controlBar2:
        "Tiempo máximo para cada cuestión. Recuerda que el tiempo empieza a contar algunos segundos después de cargar el ejercicio.",
    },
  },
  login: {
    email: "E-mail",
    password: "Contraseña",
    enter: "Entrar",
    forgotPassword: "Olvidé mi contraseña",
    forgotPasswordDescription: "Informa tu e-mail en el campo abajo y te enviaremos un correo con tu nueva contraseña.",
    forgotPasswordPostDescription: "Puedes cambiar la nueva contraseña en tu página de modificar perfil",
    backToLogin: "Volver al login",
    resetPassword: "Enviar nueva contraseña",
    resetPasswordSuccess: "Tu nueva contraseña fue enviada por e-mail.",
    unexpected_error: "No fue posible realizar el login. Trata nuevamente en algunos instantes.",
    email_not_found: "E-mail no encontrado.",
    user_not_found_in_distributor: "E-mail no encontrado.",
    user_not_found_in_company: "E-mail no encontrado.",
    invalid_password: "Contraseña inválida.",
    classroom_not_found: "Tu usuario no está asociado a una sala.",
    inactive_classroom: "Sala en período inactivo.",
    user_with_placement_in_classroom: "Completaste tu Prueba de Nivel.",
    user_disabled: "Tu usuario está desactivado.   Verifica con tu institución.",
    payment_required: "Existe una solicitud de pago abierta. Verifica tu e-mail o entra en contacto con nosotros.",
    limit_reached: "Todas las cuentas disponibles ya fueron utilizadas.",
    student_contract_blocked:
      "Oops, parece que tu acceso ha sido bloqueado. Ponte en contacto con tu profesor para obtener más información",
  },
  error: {
    required: "Obligatorio",
    invalidEmail: "E-mail inválido",
    differentPasswords: "Las contraseñas no son lo mismo",
    audioDownload: "Hubo un problema con el audio. Inténtalo de nuevo usando el botón Repetir.",
    noSpeechDetected:
      "No fue posible detectar tu habla. Verifica tu micrófono, él puede estar mudo o configurado con una sensibilidad muy baja. Intenta escuchar tu grabación para verificar el audio.",
    generalConnectionError: "Se ha detectado una inestabilidad de conexión. Por favor, haz de nuevo este ejercicio.",
    generateUnitScore: "Hubo un problema al generar tu nota.",
    emailPasswordInvalid: "Verifica tu email y/o contraseña.",
    emailNotFound: "No encotramos ningún usuario para el e-mail informado.",
    duplicatedEmail: "Ya existe un usuario con el e-mail informado.",
    updateProfileError: "Hubo un problema para actualizar tu perfil.",
    updateAvatarError: "Hubo un problema para actualizar tu avatar.",
    checkBrowserType: {
      title: "Perdona, el navegador que estás utilizando no está siendo soportado.",
      description1:
        "Para una buena experiencia en nuestra plataforma considera la utilización de la última versión del Google Chrome navegador web.",
      description2: "También puedes utilizar el Mozila Firefox o Safari.",
    },
    checkBrowserVersion: {
      title: "Tu navegador está desactualizado.",
      description:
        "Para una buena experiencia en nuestra plataforma considera la utilización de la última versión. Haz el download de la última versión en este {link}.",
    },
    checkAudioPermission: {
      title: "Casi listo",
      description:
        "Perdona, detectamos que estás usando el {browserName} navegador web y que nuestra plataforma no tiene permiso para reproducir automáticamente los audios.",
      safari: {
        description: "Sigue los pasos abajo para habilitar la reproducción de los audios:",
        step1:
          "Clica con el botón derecho en la barra de direcciones y selecciona la opción: <b>Ajuste para este site</b>",
        step2: "En la opción Reproducción Automática, selecciona: <b>Permitir todas las reproducciones automáticas</b>",
        step3: "Recarga la página y estarás listo para comenzar",
      },
      chrome: {
        description: "Clica en el botón abajo para permitir y continuar.",
        button: "Permitir y continuar",
      },
    },
    error_play_audio: "Hubo un problema y el áudio del nativo no sonó. Intenta utilizar el botón repetir de nuevo",
    error_play_record: "Hubo un problema y tu grabación no sonó. Intenta utilizar el botón escucha nuevamente",
    error_start_record: "Hubo un problema para accesar tu micrófono. Intenta utilizar el botón grabar de nuevo",
    error_stop_record: "Hubo un problema para finalizar tu grabación. Intenta utilizar el botón grabar de nuevo",
    error_find_speech_recognition_text:
      "Hubo un problema para definir la respuesta. Intenta utilizar el botón grabar una vez más",
    error_get_speech_recognition_score: "Hubo un problema para definir tu nota. Intenta grabar una vez más",
    error_no_speech: "No conseguimos detectar tu habla. Haz la grabación de nuevo",
    error_save_answer: "Hubo un problema para salvar tu respuesta. Intenta confirmar la respuesta de nuevo",
    error_inspect_html: "No se permite inspeccionar el sitio. Se perderá el progreso de esa unidad.",
    error_record_not_allowed:
      "La plataforma no tiene permiso para acceder al micrófono. Compruebe los permisos de su explorador.",
    error_record_missing_mic: "No se pudo acceder al micrófono. Compruebe la configuración de su navegador.",
    three_minute_block:
      "Usted ha concluido el ejercicio recientemente. Es necesario esperar 3 minutos para poder rehacerlo. Favor haga otro ejercicio mientras tanto.",
    error_browser_block_autoplay: "Haga clic en el botón de abajo para continuar la actividad.",
    error_browser_block_intro_autoplay: "¿Vamos a empezar? Haga clic en el botón de abajo y siga las instrucciones.",
    error_reply_ct_speak: "Parece que usted repitió la frase en vez de contestarla. Grabe su respuesta de nuevo.",
  },
  requireDesktop: {
    title: "¡Ups! Algo salió mal",
    desktopRequiredCard: {
      title: "Necesitas usar una computadora",
      description:
        "Use una computadora para realizar su examen de certificación. Usar una computadora le brindará una mejor experiencia y le permitirá realizar el examen con facilidad.",
    },
  },
};
